module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_AKTIVFREEEDOM.73a10372.png";